module.exports = __webpack_public_path__ + "img/sidebar-logo.5b4bd621.png";